import { apiRequest } from "../apiServices";

export const getQuestionSet = async (params = {}) => {
  return apiRequest({
    portal: "dmq",
    method: "get",
    endpoint: "/getQuestionSet",
    params,
  });
};

export const sendMemberResponse = async (payload) => {
  return apiRequest({
    portal: "dmq",
    method: "post",
    endpoint: "/memberResponse",
    data: payload,
  });
};

export const checkSubmissionStatus = async (memberId) => {
  return apiRequest({
    portal: "dmq",
    method: "get",
    endpoint: `/memberResponse/check?memberId=${memberId}`,
  });
};
